(function ($, window, undefined) { // Inspired by the old MinGolf
    if (window.mg === undefined)
        window.mg = {};

    if (window.mg.ui === undefined)
        window.mg.ui = {};

    var _ = window.mg;

    function _modal(options) {
        var props = $.extend(true, {
            dismissOnEsc: false,
            dismissOnOverlayClick: true,
            id: (options.idPrefix || 'modal') + _.getUniqueNumber(10),
            inline: false,
            hideClose: false,
            hideCloseText: false,
            hideFooter: false,
            hideHeader: false,
            hideButtonOK: false,
            hideButtonCancel: true,
            hideStateIcon: false,
            href: undefined, // If inline, clone the href element. Else, the idea is that we can retrieve the content with a get request, but that is not necessary yet
            html: null,
            innerOnClose: null,
            innerOnOpen: null,
            modal: undefined, // We expect this to be a jQuery object. If this is set, we use that instead of genereting the modal on our own
            modalBodyFull: false, // If this is true, the modal body stretches to the edges
            onClose: null,
            onOpen: null,
            title: 'System',
            titleInHeader: false,
            type: undefined,
            state: 'info',
            style: '',
            width: undefined,
            wide: false
        }, options);

        var existingModal = props.modal !== undefined;

        if (!existingModal) {
            var $modal = $('.templates .mg-modal-wrapper > .modal').clone();
            $modal.attr('id', props.id);

            if (props.className)
                $modal.addClass(props.className);

            if (props.state) {
                $modal.removeClass('action info error');
                $modal.addClass(props.state);
            }

            if (props.modalBodyFull)
                $modal.addClass('modal-body-full');

            if (props.wide) {
                $modal.addClass('modal-wide');
            }

            if (props.hideStateIcon)
                $modal.find('.modal-body-title > .icon').remove();

            if (props.title)
                $modal.find(props.titleInHeader ? '.modal-header > .modal-title' : '.modal-body-title > span').html(props.title);

            if (!props.showSpinner)
                $modal.find('.spinner-holder').remove();

            var content = '';

            if (props.html) {
                content = props.html;
            }
            else if (props.inline && props.href) {
                var elem = $(props.href);
                content += elem.length > 0 ? elem[0].outerHTML : '';
            }

            if (content)
                $modal.find('.modal-body').append(content);

            if (props.hideFooter)
                $modal.find('.modal-footer').remove();

            if (props.hideButtonCancel)
                $modal.find('.modal-footer .btn-cancel').remove();

            if (props.hideButtonOK)
                $modal.find('.modal-footer .btn-ok').remove();

            $('body').append($modal);
        }
        else {
            if (!options.id)
                props.id = props.modal.attr('id'); // Circumvent the auto-generated id

            if (options.dismissOnOverlayClick === undefined)
                props.dismissOnOverlayClick = props.modal.attr('data-dismiss-on-overlay-click') === 'true';

            if (options.dismissOnEsc === undefined)
                props.dismissOnEsc = props.modal.attr('data-dismiss-on-esc') === 'true';
        }

        var $elem = $('#' + props.id);
        $elem.on('shown.bs.modal', function (event) {
            onModalShown(event);
            $.isFunction(props.innerOnOpen) && props.innerOnOpen(props);
            $.isFunction(props.onOpen) && props.onOpen(props);
        });

        $elem.modal({
            backdrop: props.dismissOnOverlayClick ? true : 'static', // Default to static. If it has been specified that the modal should close when you click outside it, we set backdrop to undefined
            keyboard: props.dismissOnEsc === true
        }).on('hidden.bs.modal', function (event) {
            onModalHidden(event);
            $.isFunction(props.innerOnClose) && props.innerOnClose();
            $.isFunction(props.onClose) && props.onClose();

            !existingModal && $('#' + props.id).remove();
        });

        return $.extend(true, props, { // Add functions
            addButton: function (id, text, onClick, className) {
                $('#' + props.id + ' .modal-footer').append('<button id="' + id + '" class="btn' + (className ? ' ' + className : '') + '" type="button" onclick="' + onClick + '">' + text + '</button>');
            },
            close: function () {
                closeModal(props);
            },
            disabledElements: [],
            lock: function (restore) {
                var that = this;
                var setDisabled = function ($elem, disabled) {
                    $elem.attr('disabled', disabled);
                };

                if (restore === true) {
                    $.each(this.disabledElements, function (k, v) {
                        setDisabled($(v), false);
                    });

                    that.disabledElements = [];
                }
                else {
                    var elementsSelector = '*'; // We may want to replace this with a proper selector at some point, but for now we want to hit all elements

                    $(elementsSelector, '#' + props.id).each(function () { // Only do this if the element was not already disabled (otherwise it might be enabled on restore)
                        var $elem = $(this);

                        if (!$elem.attr('disabled')) {
                            that.disabledElements.push(this);
                            setDisabled($elem, true);
                        }
                    });
                }
            }
        });
    };

    function closeModal(props) {
        $('#' + props.id).modal('hide'); // Should trigger the hidden.bs.modal event
    }

    function getModalOpener(props) {
        return {
            close: function () {
                closeModal(props);
            }
        };
    }

    _.ui.systemmodalOpener = null;
    _.ui.systemmodal = function (options) {
        var props = $.extend(true, {
            idPrefix: 'systemModal',
            innerOnClose: function () {
                _.ui.systemmodalOpener = null;
            },
            innerOnOpen: function (props) {
                _.ui.systemmodalOpener = getModalOpener(props);
            },
            type: 'systemmodal'
        }, options);

        return _modal(props);
    }

    _.ui.minimodalOpener = null;
    _.ui.minimodal = function (options) {
        var props = $.extend(true, {
            hideButtonCancel: false, // Show this by default
            idPrefix: 'miniModal',
            innerOnClose: function () {
                _.minimodalOpener = null;
            },
            innerOnOpen: function (props) {
                _.ui.minimodalOpener = getModalOpener(props);
            },
            type: 'minimodal'
        }, options);

        return _modal(props);
    };

    _.ui.showPleaseWaitModal = function (options) { // The options object for this function is different from the other functions
        var props = $.extend(true, {
            delayed: false,
            dismissOnOverlayClick: false,
            text: '',
            title: _.translations.PleaseWait,
            showTitle: true,
            hideClose: true,
            onOpen: undefined,
            onClose: undefined
        }, options);

        var canCloseModal = false;
        var closeModal = false;
        var pleaseWaitModal = null;

        var pleaseWaitTimeout = setTimeout(function () {
            pleaseWaitModal = _.ui.systemmodal({ hideHeader: !props.showTitle, hideClose: props.hideClose, hideFooter: true, hideStateIcon: true, className: 'wait-modal', showSpinner: true, html: props.text ? '<p>' + props.text + '</p>' : '', title: props.title, dismissOnOverlayClick: props.dismissOnOverlayClick,
                onOpen: function () {
                    canCloseModal = true;

                    if (closeModal)
                        pleaseWaitModal.close();
                },
                onClose: function () { // Reset state
                    canCloseModal = false;
                    closeModal = false;
                }
            });
        }, props.delayed ? 500 : 1);

        return {
            close: function () {
                clearTimeout(pleaseWaitTimeout);

                if (canCloseModal && pleaseWaitModal) // The pleaseWaitModal can't be closed until it's rendered (unless we make it in time to stop the timeout)
                    pleaseWaitModal.close();
                else
                    closeModal = true;
            },
            onReadyInterval: null,
            onReady: function (callback) { // Implementations can wait for the modal to be shown before they perform any actions
                if (pleaseWaitModal) {
                    if (this.onReadyInterval)
                        clearInterval(this.onReadyInterval);

                    $.isFunction(callback) && callback(pleaseWaitModal);
                }
                else {
                    this.onReadyInterval = setInterval(function () {
                        this.onReady(callback);
                    }, 25);
                }
            }
        };
    };

    _.ui.statemodal = function(options) {
        return _.ui.minimodal($.extend(true, {
            hideButtonCancel: true,
            html: '',
            title: '',
            titleInHeader: false
        }, options));
    };

    _.ui.errormodal = function (options) {
        return _.ui.statemodal($.extend(true, {
            dismissOnOverlayClick: false,
            hideFooter: true,
            state: 'error'
        }, options));
    };

    _.ui.actionmodal = function (options) {
        return _.ui.statemodal($.extend(true, {
            state: 'action'
        }, options));
    };

    _.ui.confirmmodal = function(options) {
        var modal = _.ui.actionmodal($.extend(true, {
            title: mg.translations.AreYouSure,
            hideButtonOK: true,
            hideButtonCancel: true,
            useOKCancel: false
        }, options));

        var btnClass = 'btn btn-primary btn-outline-white';
        var btnYesText = options.btnYesText ? options.btnYesText : (options.useOKCancel ? _.translations.OK : _.translations.Yes);
        var btnNoText = options.btnNoText ? options.btnNoText : (options.useOKCancel ? _.translations.Cancel : _.translations.No);
        var btnYesId = options.useOKCancel ? 'btnConfirmOK' : 'btnConfirmYes';
        var btnNoId = options.useOKCancel ? 'btnConfirmCancel' : 'btnConfirmNo';

        if (!options.hideAllButtons) {
            modal.addButton(modal.id + '_' + btnYesId, btnYesText, null, btnClass);
            modal.addButton(modal.id + '_' + btnNoId, btnNoText, null, btnClass);

            $('#' + modal.id + '_' + btnYesId).on('click', function () {
                $.isFunction(options.btnYesOnClick) && options.btnYesOnClick();

                modal && modal.close(); // Close the modal
            });

            $('#' + modal.id + '_' + btnNoId).on('click', function () {
                $.isFunction(options.btnNoOnClick) && options.btnNoOnClick();

                modal && modal.close(); // Close the modal
            });
        }

        return modal;
    };

    _.ui.infomodal = function(options) {
        var modal = _.ui.statemodal($.extend(true, {
            hideButtonOK: true,
            hideStateIcon: true,
            state: 'info'
        }, options));

        if (!modal.hideButtonOK)
            $('.btn-ok', '#' + modal.id).removeClass('btn-outline-white btn-primary');

        return modal;
    };

    // Generic modal events (Inspired by miles-by-motorcycle.com/static/bootstrap-modal/index.html) (Mostly copied from oMG)
    function onModalShown(event) {
        var $modal = $(event.target);

        // Keep track of the number of open modals
        var openModalsCount = $('body').data('fv_open_modals');

        if (typeof (openModalsCount) === 'undefined') {
            openModalsCount = 0;
        }

        // If the z-index of this modal has been set, ignore
        if ($modal.hasClass('fv-modal-stack'))
            return;

        $modal.addClass('fv-modal-stack');

        $('body').data('fv_open_modals', openModalsCount + 1);

        $modal.css('z-index', 3000 + (10 * openModalsCount));

        $('.modal-backdrop').not('.fv-modal-stack').css('z-index', 2995 + (10 * openModalsCount)).addClass('fv-modal-stack');
    }

    function onModalHidden(event) {
        var $modal = $(event.target);
        $modal.removeClass('fv-modal-stack');
        $('body').data('fv_open_modals', $('body').data('fv_open_modals') - 1);

        // Attempt to run enforeFocus on the previous modal, if any. We added a .off to enforceFocus, so the previous modal's focusin events were cleared to avoid overlaps. This will set that modals focusin events again after we close this modal
        var currentlyOpenModals = getCurrentlyOpenModals();

        if (currentlyOpenModals && currentlyOpenModals.length > 0) {
            var prevModal = $(currentlyOpenModals[currentlyOpenModals.length - 1]).data('bs.modal');

            prevModal._checkScrollbar();
            prevModal._setScrollbar();
            prevModal._adjustDialog();

            prevModal._enforceFocus();
        }
    }

    function getCurrentlyOpenModals() {
        return $('.modal:visible');
    }
})(jQuery, window, undefined);
